import mixObras from '@/components/administracion/obras/mixObras';
import AGREGAR_CONTRATO from '@/graphql/mutations/administracion/contratos/agregarContrato.gql';
import ACTUALIZAR_CONTRATO from '@/graphql/mutations/administracion/contratos/actualizarContrato.gql';
import REMOVER_CONTRATO from '@/graphql/mutations/administracion/contratos/removerContrato.gql';
import CONTRATOS from '@/graphql/querys/administracion/contratos/contratosListado.gql';
import CONTRATISTAS from '@/graphql/querys/administracion/catalogos/contratistas/contratistas.gql';
import REMOVER_OBRA from '@/graphql/mutations/administracion/planeacion/removerObra.gql';
import CLIENTES from '@/graphql/querys/administracion/catalogos/clientes/clientes.gql';

export default {
  mixins: [mixObras],
  apollo: {
    clientes: {
      query: CLIENTES,
    },
    contratistas: {
      query: CONTRATISTAS,
      update({ contratistas }) {
        return contratistas;
      },
      error(error) {
        this.error = JSON.stringify(error.message);
      },
    },
  },
  // mounted() {
  //   // Listado de ejercicios
  //   this.setEjercicios();
  // },
  methods: {
    cerrarRegistrarNuevoContratista() {
      this.mostrarVentanaRegistrarNuevoContratista = false;
    },
    sumarImportesObras() {
      this.contrato.importe = this.$ObjSumar(this.obras, 'importe');
    },
    setEjercicios() {
      this.ejercicios = [];
      const min = this.contrato.ejercicio - 10;
      const max = this.contrato.ejercicio + 1;

      for (let index = max; index >= min; index -= 1) {
        this.ejercicios.push(index);
      }
    },
    setPlazo() {
      const { fechaInicio, fechaTermino } = this.contrato;
      if (!fechaInicio || !fechaTermino) return;
      const a = this.$moment(fechaInicio);
      const b = this.$moment(fechaTermino);
      this.contrato.plazo = (Number(b.diff(a, 'days')) + 1);
    },
    sumarImportesObrasFinanciada() {
      const {
        importeCostoDirecto,
        importeCostoIndirectos,
        importeUtilidad,
        importeCargosAdicionales,
        importeCostoFinanciero,
      } = this.contrato;
      this.contrato.importe = this.$numberRound(
        (importeCostoDirecto
          + importeCostoIndirectos
          + importeUtilidad
          + importeCargosAdicionales
          + importeCostoFinanciero
        ),
      );

      this.calcularTotal();
    },
    calcularTotal() {
      if (this.contrato.importe === 0 || this.contrato.porcentajeIva === 0) return;
      const importe = Number(this.contrato.importe);
      const porcentajeIVA = Number(this.contrato.porcentajeIva);
      const importeIVA = this.$numberRound(parseFloat((importe * (porcentajeIVA / 100))));
      const total = this.$numberRound(parseFloat((importe + importeIVA)));

      this.contrato.iva = importeIVA;
      this.contrato.total = total;
      this.contrato.importe = importe;
      this.contrato.porcentajeIva = porcentajeIVA;
    },
    async mixAgregarContrato() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      const { contrato } = this;
      contrato.ejercicio = Number(contrato.fecha.substr(0, 4));
      if (!this.seleccionarObras) {
        // Crear la obra
        const obra = await this.mixGuardarBasico();

        if (obra.err) {
          this.mixMensajeError(obra.err.message);
          this.enviandoFormulario = false;
          this.mixEsCargando();
          return;
        }
        // Formatear los datos de las obras
        contrato.obras.push({
          idObra: obra.data.agregarObra.id,
          importe: this.contrato.importe,
          porcentajeIva: this.contrato.porcentajeIva,
          iva: this.contrato.iva,
          total: this.contrato.total,
        });
      } else {
        contrato.obras = this.obras.map(({ id, importe }) => ({
          idObra: id,
          importe,
          porcentajeIva: this.contrato.porcentajeIva,
          iva: this.$numberRound((importe * (this.contrato.porcentajeIva / 100))),
          total: this.$numberRound((importe * ((this.contrato.porcentajeIva / 100) + 1))),
        }));
      }

      // Guardar los datos del contrato
      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO,
          variables: { contrato },
          update: (cache, { data: { agregarContrato } }) => {
            const data = cache.readQuery({ query: CONTRATOS });
            data.contratos.push(agregarContrato);
            cache.writeQuery({ query: CONTRATOS, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixActualizarContrato() {
      const { contrato } = this;
      contrato.ejercicio = Number(contrato.fecha.substr(0, 4));

      if (this.obras.length > 0) {
        // Formatear los datos de las obras
        contrato.obras = this.obras.map(({ id, importe }) => ({
          id,
          importe,
          porcentajeIva: this.contrato.porcentajeIva,
          iva: this.$numberRound((importe * (this.contrato.porcentajeIva / 100))),
          total: this.$numberRound((importe * ((this.contrato.porcentajeIva / 100) + 1))),
          esActualizacion: true,
        }));
      } else {
        // Crear la obra
        const obra = await this.mixGuardarBasico();

        if (obra.err) {
          this.mixMensajeError(obra.err.message);
          this.enviandoFormulario = false;
          this.mixEsCargando();
          return;
        }
        // Formatear los datos de las obras
        contrato.obras.push({
          idObra: obra.data.agregarObra.id,
          importe: this.contrato.importe,
          porcentajeIva: this.contrato.porcentajeIva,
          iva: this.contrato.iva,
          total: this.contrato.total,
          esActualizacion: false,
        });
      }

      // Guardar los datos del contrato
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO,
          variables: {
            id: this.contratoEditar.id,
            contrato,
          },
          update: (store, { data: { actualizarContrato } }) => {
            const data = store.readQuery({ query: CONTRATOS });
            const { contratos } = data;
            const index = contratos
              .findIndex((contratoBuscar) => contratoBuscar.id === actualizarContrato.id);
            if (index !== -1) {
              contratos.splice(index, 1, actualizarContrato);
            }
            store.writeQuery({ query: CONTRATOS, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
    async mixEliminarContrato() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      if (this.contratoEliminar.obras.length > 0) {
        this.contratoEliminar.obras.forEach(async (obra) => {
          await this.mixEliminarObra(obra.idObra);
        });
      }

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO,
        variables: {
          id: this.contratoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATOS,
          };
          const data = store.readQuery(query);
          const { contratos } = data;
          const index = contratos
            .findIndex((contrato) => contrato.id === this.contratoEliminar.id);
          if (index !== -1) {
            contratos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarObra(id) {
      await this.$apollo.mutate({
        mutation: REMOVER_OBRA,
        variables: {
          id,
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });
    },
  },
  computed: {
    mixGetClientes() {
      if (!this.clientes) return [];
      return this.clientes;
    },
  },
};
